<template>
  <Drawer :closable="false" v-model="linkDetailsDrawer" width="1000" :title="$t('key1003116')" :transfer="false" :mask="false"
    :mask-closable="false" class-name="linkDetailsStyle" @on-visible-change="linkDetailsChange">
    <template #header>
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <Icon type="md-arrow-round-forward" color="#2D8CF0" :size="28" class="cursor" @click="linkDetailsDrawer = false"/>
          <h2 class="font-size-17 font-weight-bold ml10">{{ $t('key1003116') }}</h2>
        </div>
        <div class="flex align-items-center">
          <template v-if="linkDetailsType === 'look'">
            <Button type="primary" @click="linkDetailsType = 'edit'" v-if="getPermission('ymsToker_update')">{{ $t('key1000985') }}</Button>
          </template>
          <template v-else>
            <Button @click="linkDetailsDrawer = false" class="mr15">{{ $t('key1000112') }}</Button>
            <Button type="primary" @click="linkDetailsBtn">{{ $t('key1000555') }}</Button>
          </template>
        </div>
      </div>
    </template>
    <!--链接基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003124') }}</h2>
        </template>
        <Form ref="linkInfoForm" :model="linkInfoForm" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003117')" prop="linkName">
                <span class="basic_txt pt2" v-if="linkDetailsType === 'look'">{{ linkInfoForm.linkName || '-' }}</span>
                <Input v-else :placeholder="$t('key1000324')" v-model.trim="linkInfoForm.linkName" style="width: 240px;"></Input>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1001180')" prop="createdTime">
                <span class="basic_txt">{{ linkInfoForm.createdTime || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1002962')" prop="createdByName">
                <span class="basic_txt">{{ linkInfoForm.createdByName || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003118')" prop="labelType_1">
                <span class="basic_txt">{{ linkInfoForm.labelType_1 || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003119')" prop="labelType_0">
                <span class="basic_txt">{{ linkInfoForm.labelType_0 || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003120')" prop="labelType_2">
                <span class="basic_txt">{{ linkInfoForm.labelType_2 || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003121')" prop="labelType_3">
                <span class="basic_txt">{{ linkInfoForm.labelType_3 || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="ItemCol">
              <FormItem :label="$t('key1003122')" prop="labelType_4">
                <span class="basic_txt">{{ linkInfoForm.labelType_4 || '-' }}</span>
              </FormItem>
            </Col>
            <Col :span="threeItemCol">
              <FormItem :label="$t('key1001495')" prop="remark" class="reset_textarea_styles">
                <div v-if="linkDetailsType === 'look'" class="font-size-12 pt6">{{ linkInfoForm.remark || '-' }}</div>
                <Input v-else type="textarea" :autosize="{ minRows: 4, maxRows: 10}" :placeholder="$t('key1003123')" v-model.trim="linkInfoForm.remark"></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
    <!--链接数据-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex align-items-center">
            <span class="mr10">{{ $t('key1003125') }}</span>
            <Date-picker
              type="daterange"
              style="width: 240px"
              @on-clear="resetDate"
              @on-change="getDateValue"
              :clearable="true"
              transfer
              format="yyyy-MM-dd"
              placement="bottom-end"
              :placeholder="$t('key1000360')"
              :options="dateOptions"
              :value="statisticalTime">
            </Date-picker>
          </div>
        </template>
        <div class="statistical_data_box">
          <div class="statistical_box_item" v-for="item in statisticalData">
            <p class="mb2">{{ item.name }}</p>
            <p>{{ item.value }}</p>
          </div>
        </div>
        <div id="link_echarts"></div>
      </Card>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

var myCharts;
export default {
  name: "linkDetailsDrawer",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 8,
      threeItemCol: 18,
      linkDetailsDrawer: false,
      linkDetailsType: 'look',
      linkInfoForm: {
        linkName: '',
        createdTime: '',
        createdByName: '',
        labelType_0: '', // 推广人
        labelType_1: '', // 来源渠道
        labelType_2: '', // 推广方式
        labelType_3: '', // 推广内容
        labelType_4: '', // 推广组
        remark: ''
      },
      statisticalTime: [],
      statisticalData: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003109'), paramsKey: 'numberOfClicks', value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003110'), paramsKey: 'numberOfRegistrants', value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003111'), paramsKey: 'registrationConversionRate', value: 0},
      ],
      tokerId: null,
      ruleValidate: {
        linkName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003112'), trigger: 'blur'},
        ]
      },
      userInfoList:{}
    };
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    // 初始化数据
    async initLinkDetailsData(type, tokerId, timer) {
      let v = this;
      await getAllUsersInfo().then((data) => {
        v.userInfoList = data;
      });
      v.statisticalTime = timer ? timer : [];
      v.linkDetailsType = type;
      v.tokerId = tokerId;
      let query = {
        dataView: 0,
        endCreatedTime: timer ? timer[1] : null,
        startCreatedTime: timer ? timer[0] : null,
        tokerId: tokerId,
        // source: 'YMS',
      };
      v.axios.post(api.post_ymsToker_detail, query, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            // 链接基本信息
            v.linkInfoForm.linkName = data.linkName;
            v.linkInfoForm.createdTime = data.createdTime;
            v.linkInfoForm.createdByName = getUserNameByUserId(data.createdBy, v.userInfoList);
            let labelsList = data.labelsList || [];
            if (labelsList.length > 0) {
              labelsList.map((item) => {
                let type = ['labelType_' + item.labelType];
                if (item.labelType === 0) {
                  v.linkInfoForm[type] = getUserNameByUserId(item.labelValue, v.userInfoList);
                } else {
                  v.linkInfoForm[type] = item.labelValue;
                }
              });
            }
            v.linkInfoForm.remark = data.remark;
            // 注册总数
            v.statisticalData.map((item) => {
              if (item.paramsKey === 'registrationConversionRate') {
                item.value = data[item.paramsKey] + '%';
              } else {
                item.value = data[item.paramsKey];
              }
            });
            // 分时数据
            let numberList = data.numberList || [];
            if (numberList.length > 0) {
              v.initEcharts(numberList);
            }
          }
        }
      });
      v.linkDetailsDrawer = true;
    },
    // 保存按钮
    linkDetailsBtn() {
      let v = this;
      let query = {
        linkName: v.linkInfoForm.linkName,
        remark: v.linkInfoForm.remark,
        tokerId: v.tokerId
      };
      v.$refs['linkInfoForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_ymsToker, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.linkDetailsType = 'look';
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 获取统计时间
    getDateValue(value) {
      let v = this;
      let timer = [];
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        v.registrationTime = value;
        timer = value[0] && value[1] ?
          [v.$uDate.getUniversalTime(new Date(value[0]).getTime()), v.$uDate.getUniversalTime(new Date(value[1]).getTime())] : null;
        v.initLinkDetailsData(v.linkDetailsType, v.tokerId, timer);
      }
    },
    // 重置统计时间
    resetDate() {
      this.registrationTime = [];
    },
    // 初始化echarts折线图
    initEcharts(numberList) {
      if (myCharts != null && myCharts != "" && myCharts != undefined) {
        myCharts.dispose();
      }
      myCharts = this.$echarts.init(document.getElementById('link_echarts'));
      let timer = [];
      let numberOfClicks = [];
      let numberOfRegistrants = [];
      if (numberList && numberList.length > 0) {
        numberList.map((item) => {
          timer.push(item.time);
          numberOfClicks.push(item.numberOfClicks);
          numberOfRegistrants.push(item.numberOfRegistrants);
        });
      }

      // 绘制图表
      let options = {
        title: {
          text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003113')
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003114'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003115')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timer,
        },
        yAxis: {
          minInterval: 1
        },
        series: [
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003114'), type: 'line', data: numberOfClicks,},
          {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003115'), type: 'line', data: numberOfRegistrants,}
        ]
      };
      myCharts.setOption(options);
      setTimeout(() => {
        myCharts.resize();
      }, 100);
    },
    // 监听弹窗
    linkDetailsChange(value) {
      if (!value) {
        this.tokerId = null;
        this.statisticalTime = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .linkDetailsStyle {
  .ivu-drawer-body {
    background-color: #F0F2F5;
    padding: 0;

    .basic_information_box {
      padding: 12px 12px 0 12px;

      .title_box {
        color: #333;
        font-size: 17px;
        font-weight: bold;
        background-color: #fff;
      }

      .basic_txt {
        display: inline-block;
        font-size: 12px;
        vertical-align: top;
      }
    }

    .statistical_data_box {
      border-radius: 8px;
      overflow: hidden;
      background: #F1F1F1;
      padding: 10px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .statistical_box_item {
        font-weight: bold;
        font-size: 13px;
        color: #000;
        text-align: right;
      }
    }

    #link_echarts {
      width: 900px;
      height: 400px;
      margin: 20px auto 0;
    }

    .reset_textarea_styles {
      .ivu-form-item-content {
        line-height: 20px;
      }
    }
  }
}
</style>